var map = {
	"./el-carro.jpg": 51234,
	"./el-carro.png": 1714,
	"./el-colgado.jpg": 95028,
	"./el-colgado.png": 56684,
	"./el-diablo.jpg": 54237,
	"./el-diablo.png": 56833,
	"./el-emperador.jpg": 37944,
	"./el-emperador.png": 71635,
	"./el-ermitanio.jpg": 30092,
	"./el-hermitaño.png": 10559,
	"./el-juicio.jpg": 84360,
	"./el-juicio.png": 76622,
	"./el-loco.jpg": 54470,
	"./el-loco.png": 33710,
	"./el-mago.jpg": 26710,
	"./el-mago.png": 15260,
	"./el-mundo.jpg": 64962,
	"./el-mundo.png": 4201,
	"./el-papa.jpg": 34900,
	"./el-papa.png": 99523,
	"./el-sol.jpg": 12792,
	"./el-sol.png": 44914,
	"./la-emperatriz.jpg": 62490,
	"./la-emperatriz.png": 80916,
	"./la-estrella.jpg": 48390,
	"./la-estrella.png": 82617,
	"./la-fuerza.jpg": 3170,
	"./la-fuerza.png": 65906,
	"./la-justicia.jpg": 86877,
	"./la-justicia.png": 45717,
	"./la-luna.jpg": 79366,
	"./la-luna.png": 18680,
	"./la-muerte.jpg": 12358,
	"./la-muerte.png": 19974,
	"./la-rueda-de-la-fortuna.jpg": 50699,
	"./la-rueda-de-la-fortuna.png": 80715,
	"./la-sacerdotisa.jpg": 91742,
	"./la-sacerdotisa.png": 93623,
	"./la-templanza.jpg": 62085,
	"./la-templanza.png": 45675,
	"./la-torre.jpg": 60333,
	"./la-torre.png": 76048,
	"./los-enamorados.jpg": 67424,
	"./los-enamorados.png": 81564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66685;